import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        position: "relative",
        minWidth: 0
    }
});
export default stylesheet;
